import {React,useEffect,useState} from 'react'
import { Link } from 'react-router-dom';






const Hotdeal = () => {

 

    const[days,setdays]=useState(0);
    const [hours,sethours]=useState(0);
    const[minutes,setminutes]=useState(0)
    const [seconds,setseconds]=useState(0)

    var stopdate = new Date('jan 31, 2025 00:00:00:00').getTime();
    useEffect(()=>{
      const interval = setInterval(() => {
        let currentdate = new Date().getTime()
        let distance = stopdate-currentdate
        setdays(Math.floor(distance/(1000*60*60*24)))
        sethours(Math.floor(distance/(1000*60*60)%24))
        setminutes(Math.floor(distance/(1000*60)%60))
        setseconds(Math.floor((distance/1000)%60))
        
      }, 1000);
      return()=>clearInterval(interval)
    },[seconds])

  return (
    <div className='Hotdeal-container'>
<div id='Hot-deal-haeder'>
<h1>Hot Deals</h1>
<div id='counter-container'>
<p>Shop Now</p>
</div>

<h4 ><Link style={{color:'white'}} to={'/Allproduct'}>See All</Link></h4>

</div>


    </div>
  )
}

export default Hotdeal